import React from "react";

import "./DataTable.scss";
import { SortOrder, FilterTypes } from "../../constants";
import FilterCell from "./FilterCell";
import CustomFilter from "./CustomFilter";

const TableHead = (props) => {
    const { options, currentSortOrder, currentSortColumn, onSortClick } = props;

    const handleTableHeadClick = () => {
        if (options.isSortable && onSortClick && typeof onSortClick === "function") {
            onSortClick(options);
        }
    };

    const renderSortIcon = () => {
        if (!currentSortColumn || currentSortColumn !== options.sortColumn) {
            return <i className="bx bx-sort"></i>;
        }
        return currentSortOrder === SortOrder.ASC ? (
            <i className="bx bx-sort-down"></i>
        ) : (
            <i className="bx bx-sort-up"></i>
        );
    };

    return (
        <th>
            {!options.isFilterable ? (
                <div
                    className={`data-table-head ${options.isSortable ? "sortable" : ""}`}
                    onClick={handleTableHeadClick}
                >
                    <span className="column-title">{options.title}</span>
                    <span className="sorting-icon">{options.isSortable && renderSortIcon()}</span>
                </div>
            ) : [FilterTypes.DATE_FILTER, FilterTypes.SEARCH_FILTER].includes(
                  options.filterConstants
              ) ? (
                <CustomFilter options={options} />
            ) : (
                <FilterCell options={options} />
            )}
        </th>
    );
};

export default TableHead;
